import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Navbar } from '../components/Navbar';
import { StickyCta } from '../components/StickyCta';
import { Hero } from '../components/sections/Hero';
import { SocialProof } from '../components/sections/SocialProof';
import { Pain } from '../components/sections/Pain';
import { Services } from '../components/sections/Services';
import { WhyUs } from '../components/sections/WhyUs';
import { Process } from '../components/sections/Process';
import { OnlineFormation } from '../components/sections/OnlineFormation';
import { AssetProtection } from '../components/sections/AssetProtection';
import { Outsourcing } from '../components/sections/Outsourcing';
import { TaxSection } from '../components/sections/TaxSection';
import { Testimonials } from '../components/sections/Testimonials';
import { Faq } from '../components/sections/Faq';
import { FinalCta } from '../components/sections/FinalCta';
import { Footer } from '../components/sections/Footer';
export function Landing() {
  const {
    language
  } = useLanguage();
  return <div className="w-full bg-white" data-id="element-335" data-mp="3terzbws5qjpf">
      <Navbar data-id="element-336" data-mp="3peq7efc854nc" />
      <motion.div key={language ?? 'en'} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.45,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-337" data-mp="3pegjcxaqp7ka">
        <main data-id="element-338" data-mp="l0i981d74znv">
          <Hero data-id="element-339" data-mp="l11iktos6fqa" />
          <SocialProof data-id="element-340" data-mp="kzgmgzmtioqb" />
          <Pain data-id="element-341" data-mp="l0038d0qf72r" />
          <Services data-id="element-342" data-mp="l2maebjpnkkg" />
          <WhyUs data-id="element-343" data-mp="gz6ifsil68e3" />
          <Process data-id="element-344" data-mp="gyod86dy4ju1" />
          <OnlineFormation data-id="element-345" data-mp="h07v21f932xx" />
          <AssetProtection data-id="element-346" data-mp="h114591om4j8" />
          <Outsourcing data-id="element-347" data-mp="c7y7ut5isgzc" />
          <TaxSection data-id="element-348" data-mp="c7esnk7986p0" />
          <Testimonials data-id="element-349" data-mp="c6n42tc2r988" />
          <Faq data-id="element-350" data-mp="c5v8hiih9bhy" />
          <FinalCta data-id="element-351" data-mp="794wp7dph22c" />
        </main>
        <Footer data-id="element-352" data-mp="7825szgduzmf" />
      </motion.div>
      <StickyCta data-id="element-353" data-mp="770sspft4322" />
    </div>;
}